import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Grid, TextField } from "@mui/material";
import moment from "moment";
import { getLocalStorage } from "../layout/cookies/CookieFunctions";

export default function DateRangePickerComponent({
  labelStart,
  labelEnd,
  value,
  setValue,
}) {
  const locale = getLocalStorage("locale") || "en-us";

  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      {/* DateRangePicker is not supported in the current version of @mui/x-date-pickers . Their documentation states that it will be in version 8.0.0 */}
      {/* <DateRangePicker
        startText={labelStart}
        endText={labelEnd}
        value={value}
        onChange={setValue}
        renderInput={(startProps, endProps) => (
          <>
            <TextField {...startProps} />
            <Box sx={{ mx: 2 }}> to </Box>
            <TextField {...endProps} />
          </>
        )}
      /> */}
      <Grid container spacing={1}>
        <Grid item xs={5.5}>
          <DatePicker
            fullWidth
            inputVariant="outlined"
            label={labelStart || "Start Date"}
            name="start"
            autoOk
            value={value[0]}
            onChange={(newMoment) => {
              let tempValue = [...value];
              tempValue[0] = newMoment;
              setValue(tempValue);
            }}
            renderInput={(params) => (
              <TextField {...params} fullWidth margin="normal" />
            )}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid
          item
          xs={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          to
        </Grid>
        <Grid item xs={5.5}>
          <DatePicker
            fullWidth
            inputVariant="outlined"
            label={labelEnd || "End Date"}
            name="end"
            autoOk
            value={value[1]}
            onChange={(newMoment) => {
              let tempValue = [...value];
              tempValue[1] = newMoment;
              setValue(tempValue);
            }}
            renderInput={(params) => (
              <TextField {...params} fullWidth margin="normal" />
            )}
            sx={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
}
